// import React, { useEffect, Profiler, useState } from 'react'
// // import ReactPWAInstallProvider, { useReactPWAInstall } from "react-pwa-install";
// import './Component-css/Downloadbutton.css?v=0.1'
// // let deferredPrompt;
// const Downloadbutton = () => {
//   const [supportsPWA, setSupportsPWA] = useState(false)
//   const [promptInstall, setPromptInstall] = useState(null)
//   const [showDownloadPopup, setShowDownloadPopup] = useState(true);
//   useEffect(() => {
//     const handler = e => {
//       e.preventDefault()
//       console.log('we are being triggered :D')
//       setSupportsPWA(true)
//       setPromptInstall(e)
//     }
//     window.addEventListener('beforeinstallprompt', handler)

//     return () => window.removeEventListener('transitionend', handler)
//   }, [])

//   const onClick = evt => {
//     evt.preventDefault()
//     if (!promptInstall) {

//       return
//     }
//     promptInstall.prompt()
//   }
//   if (!supportsPWA) {
//     return null
//   }


//   return (
//     <>
//       {/* // <div
//     //   className='my-stickey-footer'
//     //   style={{
//     //     position: 'fixed',
//     //     bottom: '57px',
//     //     width: '100%',
//     //     maxWidth: 480,
//     //     backgroundColor: 'transparent',
//     //     left: '0px'
//     //   }}
//     // >
//     //   <div className='text-center' style={{ zoom: '1.2', padding: '10px 0px' }}>
//     //     <button
//     //       onClick={onClick}
//     //       className='btn btn-sm text-white download_btn_bottom bounce-div'
//     //       style={{ fontWeight: 500 }}
//     //     >

//     //       DOWNLOAD OUR APP

//     //     </button>
//     //   </div>
//     // </div> */}

//       {showDownloadPopup && (
//         <div
//           className="mlk_blue_download_overlay"
//           onClick={() => setShowDownloadPopup(false)}
//         >
//           <div
//             className="mlk_blue_download_popup"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="mlk_blue_handle"></div>

//             <div className="mlk_popup_logo_wrap">
//               <img src="../images/box-ludo-logo.png" className="mlk_popup_logo" alt="" />
//             </div>

//             <h3>Download Box Ludo App</h3>

//             <p>
//               Play Faster • Better Performance • Instant Access
//             </p>

//             <div className="mlk_blue_btns">

//               <button
//                 className="mlk_later_btn"
//                 onClick={() => {
//                   localStorage.setItem("downloadPopupClosed", "true");
//                   setShowDownloadPopup(false);
//                 }}
//               >
//                 Later
//               </button>

//               <button
//                 className="mlk_download_now_btn"
//                 onClick={onClick}
//               >

//                 <span className="mlk_download_icon">
//                   ⬇
//                 </span>

//                 <span>
//                   Download App
//                 </span>

//               </button>

//             </div>

//           </div>
//         </div>
//       )}
//     </>
//   )
// }

// export default Downloadbutton



import React, { useEffect, useState } from "react";
import "./Component-css/Downloadbutton.css?v=0.2";

const Downloadbutton = () => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);
  const [showDownloadPopup, setShowDownloadPopup] = useState(true);

  useEffect(() => {
    const handler = (event) => {
      event.preventDefault();
      setSupportsPWA(true);
      setPromptInstall(event);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  const closePopup = () => {
    localStorage.setItem("downloadPopupClosed", "true");
    setShowDownloadPopup(false);
  };

  const onClick = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (promptInstall) {
      await promptInstall.prompt();

      const choice = await promptInstall.userChoice;

      if (choice?.outcome === "accepted") {
        setShowDownloadPopup(false);
      }

      setPromptInstall(null);
      setSupportsPWA(false);
      return;
    }

    // The native installation prompt is unavailable.
    // Show a helpful fallback instead of doing nothing.
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      alert(
        'To install the app, tap the Share button in Safari and select "Add to Home Screen".'
      );
    } else {
      alert(
        "App installation is not available right now. Please open the browser menu and check whether Install App or Add to Home Screen is available."
      );
    }
  };

  // Preserve the existing PWA-support condition.
  if (!supportsPWA) {
    return null;
  }

  return (
    <>
      {showDownloadPopup && (
        <div
          className="mlk_blue_download_overlay"
          onClick={closePopup}
        >
          <div
            className="mlk_blue_download_popup"
            onClick={(event) => event.stopPropagation()}
          >
            {/* Close button */}
            <button
              type="button"
              className="mlk_popup_close_btn"
              onClick={closePopup}
              aria-label="Close download popup"
            >
              <span aria-hidden="true">&times;</span>
            </button>

            {/* Main promotional image */}
            <div className="mlk_download_artwork">
              <img
                src="/images/app-download.png"
                alt="Download Box Ludo App"
                className="mlk_download_banner_image"
              />

              {/* Clickable download button over the image button area */}
              <button
                type="button"
                className="mlk_download_image_action"
                onClick={onClick}
                aria-label="Download Box Ludo App"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Downloadbutton;
